var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 12.625C7.07031 12.625 7.5 13.0547 7.5 13.5625C7.5 14.1094 7.07031 14.5 6.5625 14.5H4.6875C4.14062 14.5 3.75 14.1094 3.75 13.5625C3.75 13.0547 4.14062 12.625 4.6875 12.625H6.5625ZM14.0625 12.625C14.5703 12.625 15 13.0547 15 13.5625C15 14.1094 14.5703 14.5 14.0625 14.5H9.6875C9.14062 14.5 8.75 14.1094 8.75 13.5625C8.75 13.0547 9.14062 12.625 9.6875 12.625H14.0625ZM20 0.75C21.3672 0.75 22.5 1.88281 22.5 3.25V15.75C22.5 17.1562 21.3672 18.25 20 18.25H2.5C1.09375 18.25 0 17.1562 0 15.75V3.25C0 1.88281 1.09375 0.75 2.5 0.75H20ZM20 2.625H2.5C2.14844 2.625 1.875 2.9375 1.875 3.25V4.5H20.625V3.25C20.625 2.9375 20.3125 2.625 20 2.625ZM20.625 8.25H1.875V15.75C1.875 16.1016 2.14844 16.375 2.5 16.375H20C20.3125 16.375 20.625 16.1016 20.625 15.75V8.25Z",
    fill: "#3C3C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLogo);
export default __webpack_public_path__ + "static/media/CardLogo.ae53443f8f4fc0831ac8f2d44804284d.svg";
export { ForwardRef as ReactComponent };